var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAlarmLeak = function SvgAlarmLeak(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    fill: "currentColor",
    transform: "translate(0 -1028.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4147",
    d: "M14.395 1028.5a5.65 5.65 0 0 0-4.957 2.962 4.3 4.3 0 0 0-1.059-.139c-2.13 0-3.907 1.57-4.245 3.608A4.19 4.19 0 0 0 0 1039.107a4.19 4.19 0 0 0 4.179 4.179h14.767c2.781 0 5.054-2.277 5.054-5.06 0-2.436-1.742-4.483-4.043-4.957-.42-2.693-2.755-4.77-5.562-4.77zm-.08 1.714a4.083 4.134 0 0 1 .053 0h.027a3.9 3.9 0 0 1 3.471 2.099 4.083 4.134 0 0 1 .533 2.036 4.083 4.134 0 0 1-.03.467 3.368 3.41 0 0 1 .546-.046 3.368 3.41 0 0 1 3.326 2.9 3.368 3.41 0 0 1 .001.01 3.368 3.41 0 0 1 .026.213q.017.163.018.331a3.33 3.33 0 0 1-2.001 3.065c-.012.01-.023.012-.035.017a3.368 3.41 0 0 1-1.335.282 3.368 3.41 0 0 1-.342-.018H4.408a2.786 2.464 0 0 1-.112-.01c-.04 0-.077.01-.117.01a2.45 2.45 0 0 1-2.464-2.465 2.786 2.464 0 0 1 .01-.195 2.45 2.45 0 0 1 2.454-2.269h.02l.004.014a2.786 2.464 0 0 1 .298-.015 2.786 2.464 0 0 1 1.09.196 3.214 3.255 0 0 1-.073-.665 3.214 3.255 0 0 1 1.131-2.477q.052-.043.106-.083a3.214 3.255 0 0 1 .218-.16l.112-.07a3.214 3.255 0 0 1 1.648-.464 3.214 3.255 0 0 1 1.621.449 4.083 4.134 0 0 1 3.962-3.154z",
    color: "currentColor",
    colorRendering: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    style: {
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal",
      textDecorationColor: "#000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path4218",
    d: "m6.656 1045-2.667 1.436a1.71 1.71 0 0 0-.989 1.55 1.714 1.714 0 0 0 1.714 1.715 1.714 1.714 0 0 0 1.696-1.476h.006l.24-3.23z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path4223",
    d: "m13.085 1047.6-2.667 1.436a1.71 1.71 0 0 0-.99 1.55 1.714 1.714 0 0 0 1.715 1.715 1.714 1.714 0 0 0 1.696-1.476h.006l.24-3.23z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path4225",
    d: "m19.513 1044.1-2.667 1.436a1.71 1.71 0 0 0-.99 1.55 1.714 1.714 0 0 0 1.715 1.715 1.714 1.714 0 0 0 1.696-1.476h.006l.24-3.23z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAlarmLeak);
export default ForwardRef;